import { Button, Form, Select, DatePicker, Table, Spin, Image, notification } from "antd";
import { useState, useRef, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row as Brow, Col as Bcol } from "reactstrap";
import { CSVLink } from "react-csv";
import numeral from "numeral";
import moment from "moment";
import csv from "../../assets/images/csv.png";
import pdf from "../../assets/images/PDF_file_icon.svg.png";
import { getBookSummary } from "../../redux/actions/bookSummary.action";
import PageHeader from "../../components/PageHeader/PageHeader";
import { ReadCookie } from "../../utils/readCookie";
import { TabTitle } from "../../utils/GeneralFunction";
import { loadCustomers } from "../../redux/actions/customerForm";
import { getPendingSummary } from "../../redux/actions/pendingSummary.action";
import { getPendingPodSummary } from "../../redux/actions/pendingPodSummary.action";
import { getShippedSummary } from "../../redux/actions/shippedSummary.action";
import { getReturnSummary } from "../../redux/actions/returnSummary.action";
import { columns, columnsPending, columnsPodSummary, columnShippedSummary, columnsReturnSummary } from "./column"
import { getCrmCustomerReport } from "../../redux/actions/crmCustomerReport.action";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import axios from "axios";
import { saveAs } from "file-saver";
import { BASEURL } from "../../constant/config";
const { Option } = Select;

const CRMReport = () => {
  TabTitle("CRM Report")
  const [form] = Form.useForm();
  const [minimize, setMinimize] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const menuId = ReadCookie("menuId");
  const token = ReadCookie("token");
  const queryParams = new URLSearchParams(window.location.search);
  const customerID = queryParams.get("customer_id");
  const tableRef = useRef(null);
  const companyId = ReadCookie("defaultCompany");
  const { customerForms, getBookSummaryReducer, getPendingSummaryReducer, pendingPodSummary, getShippedSummaryReducer, getReturnSummaryReducer, CrmCustomerReport } = useSelector((state) => state);
  const focusInput = useRef(null);
  const [customer, setCustomer] = useState("All");

  const [bookSummaryList, setBookSummaryList] = useState([]);
  const [pendingSummaryList, setPendingSummaryList] = useState([]);
  const [pendingPODSummaryList, setPendingPODSummaryList] = useState([]);
  const [shippedSummaryList, setShippedSummaryList] = useState([]);
  const [returnSummaryList, setReturnSummaryList] = useState([]);
  const [crmCustomerReportList, setCrmCustomerReportList] = useState([]);


  const [bookSummaryExcelData, setBookSummaryExcelData] = useState([]);
  const [pendingSummaryExcelData, setPendingSummaryExcelData] = useState([]);
  const [pendingPODSummaryExcelData, setPendingPODSummaryExcelData] = useState([]);
  const [shippedSummaryExcelData, setShippedSummaryExcelData] = useState([]);
  const [returnSummaryExcelData, setReturnSummaryExcelData] = useState([]);




  function downloadExcelFileData(data, type) {
    if (type === 'bookSummary') {
      setBookSummaryExcelData(
        data.map((v) => {
          return {
            "Order #": v.order_header_no,
            "Order Date": moment(v.order_date).format("MM-DD-YY"),
            "PO #": v.reference_no,
            "Start Date": moment(v.start_date).format("MM-DD-YY"),
            "Cancel Date": moment(v.cancel_date).format("MM-DD-YY"),
            "Customer": v.customer_name,
            "Billing Addressee": v.billing_addressee,
            "Payment Term": v.payment_term,
            "Quantity": parseFloat(v.quantity).toFixed(0),
            "Net Amount": numeral(v.net).format("0,0.00"),
            "CIT Status": v.factor_decision,
            "Source": v.source_type,
            "Status": v.status,
            "Loaction": v.location_name,
            "Store": v.store_id,
            "DC #": v.dc_no,
            "Department code": v.department_code,
            "Gender": v.gender_name,
            "Sale person Name": v.salesperson_name,
            "Region": v.region_name,
            "State": v.state_name,
            "Resale Expiry": moment(v.resaleexpiry).format("MM-DD-YYYY"),
            "Resale #": v.resaleno,
          };
        })
      );
    } else if (type === 'pendingSummary') {
      setPendingSummaryExcelData(
        data.map((v) => {
          return {
            "Order #": v.order_header_no,
            "Order Date": moment(v.order_date).format("MM-DD-YY"),
            "PO #": v.reference_no,
            "Customer": v.customer_name,
            "Billing Addressee": v.billing_addressee,
            "Start Date": moment(v.start_date).format("MM-DD-YY"),
            "Cancel Date": moment(v.cancel_date).format("MM-DD-YY"),
            "Pending Quantity": parseFloat(v.quantity).toFixed(0),
            "Commited": parseFloat(v.quantity_committed).toFixed(0),
            "Pending Amount": numeral(v.net).format("0,0.00"),
            "Term": v.payment_term,
            "CIT Status": v.factor_decision,
            "Order Status": v.status,
            "Hold Status": v.holdstatus,
            "Region": v.region_name,
            "Loaction": v.location_name,
            "Sale person Name": v.salesperson_name,
            "Gender": v.gender_name,
            "Customer Type": v.customer_type_name,
            "Billing State": v.state_name,
            "Resale #": v.resaleno,
            "Resale Expiry": moment(v.resaleexpiry).format("MM-DD-YYYY"),
            "Store": v.store_id,
            "Shipping Zip": v.shipping_zip,
            "Shipper": v.ship_via_description,
            "Bergan Billing": v.bergan_billing_name,
          };
        })
      );
    } else if (type === 'pendingPODSummary') {
      setPendingPODSummaryExcelData(
        data.map((v) => {
          return {
            "PT #": v.ship_header_no,
            "PT Date": moment(v.ship_date).format("MM-DD-YY"),
            "Cancel Date": moment(v.cancel_date).format("MM-DD-YY"),
            "Customer": v.billingcustomer,
            "Billing Addressee": v.billing_addressee,
            "SO #": v.order_header_no,
            "PO #": v.reference_no,
            "PT Qty": numeral(v.quantity).format("0,00"),
            "Amount": parseFloat(v.amount).toFixed(2),
            "Term": v.payment_term,
            "Sale person": v.salesperson_name,
            "Region": v.region_name,
            "PT Status": v.pt_status_name,
            "NS Status": v.ship_status_name,
            "Loaction": v.location_name,
          };
        })
      );
    } else if (type === 'shippedSummary') {
      setShippedSummaryExcelData(
        data.map((v) => {
          return {
            "invoice_no": v.invoice_header_no,
            "Invoice Date": moment(v.invoice_date).format("MM-DD-YYYY"),
            "PT #": v.ship_header_no,
            "Order #": v.order_header_no,
            "PO #": v.reference_no,
            "Billing Customer": v.billingcustomer,
            "Payment Term": v.payment_term,
            "Billing City": v.city_name,
            "Billing State": v.bill_state_name,
            "Shipping State": v.ship_state_name,
            "Tracking #": v.tracking_no,
            "Customer Category": v.customer_type_name,
            "Status": v.status,
            "Quantity": parseFloat(v.quantity).toFixed(0),
            "Amount": parseFloat(v.net).toFixed(2),
            "Due Date": moment(v.due_date).format("MM-DD-YYYY"),
            "Gender": v.gender_name,
            "EDI #": v.edi,
            "Region": v.region_name,
            "Salesperson": v.salesperson_name,
            "Scf No": v.scf_no,
            "Store": v.store_id,
            "Order Date": moment(v.order_date).format("MM-DD-YYYY"),
            "Payment Class": v.factor_name,
          };
        })
      );
    } else if (type === 'returnSummary') {
      setReturnSummaryExcelData(
        data.map((v) => {
          return {
            "CN #": `CN-${v.note_header_no}`,
            "CN Date": moment(v.note_date).format("MM-DD-YYYY"),
            "RA #": v.return_header_no,
            "INV #": v.invoice_header_no,
            "PO #": v.reference_no,
            "Billing Customer": v.billingcustomer,
            "Quantity": parseFloat(v.quantity).toFixed(0),
            "Amount": Number(v.net).toFixed(2),
            "Payment Term": v.payment_term,
            "Region": v.region_name,
            "Gender": v.gender_name,
            "PT #": v.ship_header_no,
            "ASN #": v.asn_no,
            "RA Approval #": v.ra_aproval,
            "Sale person Name": v.salesperson_name,
            "Country": v.country_name,
            "City": v.city_name,
            "Location": v.location_name,
            "State": v.state_name,
            "Address": v.full_address,
          };
        })
      );
    }
  }


  function downloadPDFFileData(data, type) {
    const doc = new jsPDF('landscape', 'pt', 'a4');

    let title = '';
    let headers = [];
    let rows = [];

    switch (type) {
      case 'bookSummary':
        title = "Book Summary";
        headers = [
          "S#", "Order #", "Order Date", "PO #", "Start Date", "Cancel Date", "Customer",
          "Billing Addressee", "Payment Term", "Quantity", "Net Amount", "CIT Status",
          "Source", "Status", "Location", "Store", "DC #", "Department code", "Gender",
          "Sale person Name", "Region", "State", "Resale Expiry", "Resale #"
        ];
        rows = data.map((v, index) => [
          index + 1,
          v.order_header_no,
          moment(v.order_date).format("MM-DD-YY"),
          v.reference_no,
          moment(v.start_date).format("MM-DD-YY"),
          moment(v.cancel_date).format("MM-DD-YY"),
          v.customer_name,
          v.billing_addressee,
          v.payment_term,
          parseFloat(v.quantity).toFixed(0),
          numeral(v.net).format("0,0.00"),
          v.factor_decision,
          v.source_type,
          v.status,
          v.location_name,
          v.store_id,
          v.dc_no,
          v.department_code,
          v.gender_name,
          v.salesperson_name,
          v.region_name,
          v.state_name,
          v.resaleexpiry === "N/A" ? v.resaleexpiry : moment(v.resaleexpiry).format("MM-DD-YYYY"),
          v.resaleno,
        ]);
        break;

      case 'pendingSummary':
        title = "Pending Summary";
        headers = [
          "S#", "Order #", "Order Date", "PO #", "Customer", "Billing Addressee", "Start Date",
          "Cancel Date", "Pending Quantity", "Commited", "Pending Amount", "Term", "CIT Status",
          "Order Status", "Hold Status", "Region", "Location", "Sale person Name", "Gender",
          "Customer Type", "Billing State", "Resale #", "Resale Expiry", "Store", "Shipping Zip",
          "Shipper", "Bergan Billing"
        ];
        rows = data.map((v, index) => [
          index + 1,
          v.order_header_no,
          moment(v.order_date).format("MM-DD-YY"),
          v.reference_no,
          v.customer_name,
          v.billing_addressee,
          moment(v.start_date).format("MM-DD-YY"),
          moment(v.cancel_date).format("MM-DD-YY"),
          parseFloat(v.quantity).toFixed(0),
          parseFloat(v.quantity_committed).toFixed(0),
          numeral(v.net).format("0,0.00"),
          v.payment_term,
          v.factor_decision,
          v.status,
          v.holdstatus,
          v.region_name,
          v.location_name,
          v.salesperson_name,
          v.gender_name,
          v.customer_type_name,
          v.state_name,
          v.resaleno,
          moment(v.resaleexpiry).format("MM-DD-YYYY"),
          v.store_id,
          v.shipping_zip,
          v.ship_via_description,
          v.bergan_billing_name,
        ]);
        break;

      case 'pendingPODSummary':
        title = "Pending POD Summary";
        headers = [
          "S#", "PT #", "PT Date", "Cancel Date", "Customer", "Billing Addressee", "SO #", "PO #",
          "PT Qty", "Amount", "Term", "Sale Person Name", "Region", "PT Status", "NS Status", "Location"
        ];
        rows = data.map((v, index) => [
          index + 1,
          v.ship_header_no,
          moment(v.ship_date).format("MM-DD-YY"),
          moment(v.cancel_date).format("MM-DD-YY"),
          v.billingcustomer,
          v.billing_addressee,
          v.order_header_no,
          v.reference_no,
          numeral(v.quantity).format("0,00"),
          parseFloat(v.amount).toFixed(2),
          v.payment_term,
          v.salesperson_name,
          v.region_name,
          v.pt_status_name,
          v.ship_status_name,
          v.location_name,
        ]);
        break;

      case 'shippedSummary':
        title = "Shipped Summary";
        headers = [
          "S#",
          "invoice_no",
          "Invoice Date",
          "PT #",
          "Order #",
          "PO #",
          "Billing Customer",
          "Payment Term",
          "Billing City",
          "Billing State",
          "Shipping State",
          "Tracking #",
          "Customer Category",
          "Status",
          "Quantity",
          "Amount",
          "Due Date",
          "Gender",
          "EDI #",
          "Region",
          "Salesperson",
          "Scf No",
          "Store",
          "Order Date",
          "Payment Class"
        ];
        rows = data.map((v, index) => [
          index + 1,
          v.invoice_header_no,
          moment(v.invoice_date).format("MM-DD-YYYY"),
          v.ship_header_no,
          v.order_header_no,
          v.reference_no,
          v.billingcustomer,
          v.payment_term,
          v.city_name,
          v.bill_state_name,
          v.ship_state_name,
          v.tracking_no,
          v.customer_type_name,
          v.status,
          parseFloat(v.quantity).toFixed(0),
          parseFloat(v.net).toFixed(2),
          moment(v.due_date).format("MM-DD-YYYY"),
          v.gender_name,
          v.edi,
          v.region_name,
          v.salesperson_name,
          v.scf_no,
          v.store_id,
          moment(v.order_date).format("MM-DD-YYYY"),
          v.factor_name,
        ]);
        break;

      case 'returnSummary':
        title = "Return Summary";
        headers = [
          "S#",
          "CN #",
          "CN Date",
          "RA #",
          "INV #",
          "PO #",
          "Billing Customer",
          "Quantity",
          "Amount",
          "Payment Term",
          "Region",
          "Gender",
          "PT #",
          "ASN #",
          "RA Approval #",
          "Sale person Name",
          "Country",
          "City",
          "Location",
          "State",
          "Address",
        ];
        rows = data.map((v, index) => [
          index + 1,
          `CN-${v.note_header_no}`,
          moment(v.note_date).format("MM-DD-YYYY"),
          v.return_header_no,
          v.invoice_header_no,
          v.reference_no,
          v.billingcustomer,
          parseFloat(v.quantity).toFixed(0),
          Number(v.net).toFixed(2),
          v.payment_term,
          v.region_name,
          v.gender_name,
          v.ship_header_no,
          v.asn_no,
          v.ra_aproval,
          v.salesperson_name,
          v.country_name,
          v.city_name,
          v.location_name,
          v.state_name,
          v.full_address,
        ]);
        break;

      default:
        title = 'Summary Report';
        break;
    }

    doc.setFontSize(12);
    doc.text(title, 10, 20, { align: 'left' });

    // Table
    doc.setFontSize(4);
    autoTable(doc, {
      startY: 30, // Start after title
      margin: { top: 10, bottom: 10, left: 10, right: 10 },
      head: [headers],
      body: rows,
      theme: 'plain',
      styles: {
        fontSize: 4,
        cellPadding: 4,
        textColor: '#000000',
        halign: 'left',
        valign: 'middle',
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: '#000000',
        fontStyle: 'bold',
        lineWidth: 0.5,
        lineColor: '#000000',
      },
      bodyStyles: {
        lineWidth: 0.2,
        lineColor: '#000000',
      },
    });

    // Save with title as file name
    doc.save(`${title}.pdf`);
  }



  function debounce(cb, delay = 1000) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }

  const handleChanges = (val) => {
    if (val === "" || val === "All") return;
    setCustomer(val);
    dispatch(loadCustomers(token, null, null, null, null, null, val, null, null, null, null, null, null, null, null, null, null, null, null)).then(
      (res) => {
        if (res?.type === "GET_ALL_CUSTOMERS_SUCCESS") {
          setCustomer(res?.payload?.data);
        }
      }
    );
  };

  const optimizedFn = useCallback(debounce(handleChanges), []);


  const onFinish = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();
      const summaryRequests = [
        getBookSummary(token, values),
        getPendingSummary(token, values),
        getPendingPodSummary(token, values),
        getShippedSummary(token, values),
        getReturnSummary(token, values),
        getCrmCustomerReport(token, values)
      ];

      const [
        bookSummaryRes,
        pendingSummaryRes,
        pendingPODSummaryRes,
        shippedSummaryRes,
        returnSummaryRes,
      ] = await Promise.all(summaryRequests.map(dispatch));

      setBookSummaryList(bookSummaryRes?.payload?.data);
      setPendingSummaryList(pendingSummaryRes?.payload?.data);
      setPendingPODSummaryList(pendingPODSummaryRes?.payload?.data);
      setShippedSummaryList(shippedSummaryRes?.payload?.data);
      setReturnSummaryList(returnSummaryRes?.payload?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };




  let sumQtyBook = bookSummaryList.reduce(function (previousValue, currentValue) { return previousValue += Number(currentValue.quantity) }, 0);
  let sumAmountBook = bookSummaryList.reduce(function (previousValue, currentValue) { return previousValue += Number(currentValue.net); }, 0);
  let sumQtyPending = pendingSummaryList.reduce(function (previousValue, currentValue) { return previousValue += Number(currentValue.pendind_qty); }, 0);
  let sumAmountPending = pendingSummaryList.reduce(function (previousValue, currentValue) { return previousValue += Number(currentValue.net); }, 0);
  let sumQtyPOD = pendingPODSummaryList.reduce(function (previousValue, currentValue) { return previousValue += Number(currentValue.quantity); }, 0);
  let sumAmountPOD = pendingPODSummaryList.reduce(function (previousValue, currentValue) { return previousValue += Number(currentValue.amount); }, 0);
  let sumQtyShipped = shippedSummaryList.reduce(function (previousValue, currentValue) { return previousValue += Number(currentValue.quantity); }, 0);
  let sumAmountShipped = shippedSummaryList.reduce(function (previousValue, currentValue) { return previousValue += Number(currentValue.net); }, 0);
  let sumQtyReturn = returnSummaryList.reduce(function (previousValue, currentValue) { return previousValue += Number(currentValue.quantity); }, 0);
  let sumAmountReturn = returnSummaryList.reduce(function (previousValue, currentValue) { return previousValue += Number(currentValue.net); }, 0);


  const groupedData = CrmCustomerReport?.payload?.data?.reduce((acc, item) => {
    if (!acc[item.month_name]) {
      acc[item.month_name] = [];
    }
    acc[item.month_name].push(item);
    return acc;
  }, {}) || {};

  console.log("groupedData", groupedData)
  // Desired sequence

  const monthOrder = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const sortedEntries = Object.entries(groupedData).sort(([a], [b]) => {
    const [yearA, monthA] = a.trim().split(" ");
    const [yearB, monthB] = b.trim().split(" ");

    if (yearA !== yearB) {
      return parseInt(yearA) - parseInt(yearB);
    }

    return monthOrder.indexOf(monthA) - monthOrder.indexOf(monthB);
  });

  const notificationKey = `open${Date.now()}`;
  const load = <div className="d-flex"><span className="spin-color mx-2">
    <Spin size="small" />
  </span><p>Please wait for a few minutes</p></div>;

  const handleDownload = async () => {
    try {
      // form.setFields("gender_id",isGenerate)
      notification.open({
        message: "Preparing PDF Download...",
        description: load,
        key: notificationKey,
        duration: 0,
      });

      await form.validateFields().then(async (values) => {
        const data = {
          from_date: moment(values.from_date).format("MM-DD-YYYY"),
          to_date: moment(values.to_date).format("MM-DD-YYYY"),
          customer_id: values.customerNew === undefined || values.customerNew === "All" ? null : values.customerNew,
        }
        const response = await axios.post(`${BASEURL}getAll/DownloadCrmShipWiseSkuImages`, { data }, {
          responseType: "blob", // Important!
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const blob = new Blob([response.data], {
          type: "application/pdf"
        });
        saveAs(blob, "CRM-Images.pdf");

        notification.destroy({ key: notificationKey });
        notification.success({
          message: "Download Successful",
          description: "Your PDF report has been downloaded.",
          className: "toast-success",
        });
      });
    } catch (error) {
      console.error("Download failed", error);

      // Destroy loader and show error notification
      notification.destroy({ key: notificationKey });
      notification.error({
        message: "Download Failed",
        description: "Something went wrong while downloading the PDF report.",
        className: "toast-error",
      });
    }
  };


  return (
    <div className="styleContainer">
      <div className="styleBodyPendingSummary">
        <PageHeader
          title={"CRM Report"}
          minimize={setMinimize}
          check={minimize}
        />
        {!minimize && (
          <div className="bodyStyle">
            <div className="formProduct p-2">
              <Form onFinish={onFinish} form={form} name="control-hooks">
                <div className="container-fluid pbpx-5 ptpx-5">
                  <Brow>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div className="">
                        <div className="relative">
                          <Form.Item
                            name="from_date"
                            label="From Date:"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                            initialValue={moment().startOf('year')}
                          >
                            <DatePicker
                              size='small'
                              className="styleInput w-100"
                              format={"MM-DD-YYYY"}
                              defaultValue={moment().format("MM-DD-YYYY")}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div >
                        <div className="relative">
                          <Form.Item
                            name="to_date"
                            label="To Date:"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                            initialValue={moment().endOf('year')}
                          >
                            <DatePicker
                              size='small'
                              className="styleInput w-100"
                              format={"MM-DD-YYYY"}
                              defaultValue={moment().format("MM-DD-YYYY")}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div >
                        <div className="relative">
                          <Form.Item
                            name="customerNew"
                            label="Customer:"
                            labelAlign="left"
                            rules={[
                              {
                                required: true,
                                message: "Customer is Required",
                              },
                            ]}
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <Select
                              showSearch
                              allowClear
                              optionFilterProp="children"
                              loading={customerForms.loading}
                              size="small"
                              onSearch={(value) => {
                                optimizedFn(value);
                              }}
                              ref={focusInput}
                              value={customer}
                            >
                              {customerForms?.payload?.data.map((item) => {
                                return (
                                  <Option
                                    key={item.customer_id} value={item.customer_id}
                                  >
                                    {" "}
                                    {`${item.customer_code} ${item.customer_name}`}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                  </Brow>
                </div>
              </Form>
              <Button
                htmlType="submit"
                type="primary"
                className="submit-btn-btm mb-2 mrpx-10"
                onClick={onFinish}
              >
                Submit
              </Button>
            </div>
          </div>
        )}
      </div>
      <div style={{ marginTop: 10 }}>
        {
          loading ? (
            <div className=" report-wrapper-main d-flex align-items-center justify-content-center spin-style mt-3">
              <Spin size='large' />
            </div>
          ) : (
            bookSummaryList && bookSummaryList.length > 0 ? (
              <>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ fontSize: "16px", textDecoration: "underline", textDecorationThickness: 2 }}>
                    Booked Summary
                  </div>
                  <div style={{ display: "flex", gap: "15px" }}>
                    <CSVLink
                      filename={"booked-summary.csv"}
                      data={bookSummaryExcelData}
                      onClick={() => downloadExcelFileData(bookSummaryList, 'bookSummary')}
                    >
                      <span className="print_icon printing_class">
                        <input
                          style={{ height: "30px" }}
                          type="image"
                          name="ImgExcel"
                          alt="Export to excel"
                          id="ImgExcel"
                          title="Export to excel"
                          src={csv}
                        />
                      </span>
                    </CSVLink>
                    <span className="print_icon printing_class" onClick={() => downloadPDFFileData(bookSummaryList, 'bookSummary')}>
                      <input
                        style={{ height: "30px", cursor: "pointer" }}
                        type="image"
                        name="ImgPdf"
                        alt="Export to PDF"
                        id="ImgPdf"
                        title="Export to PDF"
                        src={pdf}
                      />
                    </span>
                  </div>
                </div>
                <Table
                  ref={tableRef}
                  size="small"
                  bordered={false}
                  type="company"
                  scroll={{ x: 'max-content' }}
                  rowKey="order_header_id"
                  dataSource={bookSummaryList}
                  columns={columns}
                  loading={getBookSummaryReducer.loading}

                  pagination={{
                    defaultCurrent: 1,
                    defaultPageSize: 5,
                    pageSizeOptions: [5, 20, 50, 100, 200]
                  }}
                  summary={(pageData) => {
                    let sumQty = pageData.reduce(function (
                      previousValue,
                      currentValue
                    ) {
                      return (previousValue += parseFloat(
                        currentValue.quantity
                      ));
                    },
                      0);
                    let Net = pageData.reduce(function (
                      previousValue,
                      currentValue
                    ) {
                      return (previousValue += parseFloat(
                        currentValue.net
                      ));
                    },
                      0);
                    return (
                      <>
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={2}>Total Quantity : {numeral(sumQtyBook).format("0,00,0")}
                          </Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <p style={{ textAlign: "right" }} className="totalquantity">
                              {sumQty.toLocaleString("en-US")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <p style={{ textAlign: "right" }} className="totalquantity">
                              $ {numeral(Net).format('0,0.00')}
                            </p>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={2} style={{ paddingTop: "10px", fontWeight: "bolder" }}>Total Amount : ${numeral(sumAmountBook).format("0,0.00")}
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      </>
                    );
                  }}
                />

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ fontSize: "16px", textDecoration: "underline", textDecorationThickness: 2 }}>
                    Pending Summary
                  </div>
                  <div style={{ display: "flex", gap: "15px" }}>
                    <CSVLink
                      filename={"booked-summary.csv"}
                      data={pendingSummaryExcelData}
                      onClick={() => downloadExcelFileData(pendingSummaryList, 'pendingSummary')}
                    >
                      <span className="print_icon printing_class">
                        <input
                          style={{ height: "30px" }}
                          type="image"
                          name="ImgExcel"
                          alt="Export to excel"
                          id="ImgExcel"
                          title="Export to excel"
                          src={csv}
                        />
                      </span>
                    </CSVLink>
                    <span className="print_icon printing_class" onClick={() => downloadPDFFileData(pendingSummaryList, 'pendingSummary')}>
                      <input
                        style={{ height: "30px", cursor: "pointer" }}
                        type="image"
                        name="ImgPdf"
                        alt="Export to PDF"
                        id="ImgPdf"
                        title="Export to PDF"
                        src={pdf}
                      />
                    </span>
                  </div>
                </div>
                <Table
                  ref={tableRef}
                  size="small"
                  bordered={false}
                  type="company"
                  scroll={{ x: 'max-content' }}
                  perPage={5}
                  dataSource={pendingSummaryList}
                  columns={columnsPending}
                  loading={getPendingSummaryReducer.loading}
                  pagination={{
                    defaultCurrent: 1,
                    defaultPageSize: 5,
                    pageSizeOptions: [5, 20, 50, 100, 200]
                  }}
                  summary={(pageData) => {
                    let PendingQuantity = pageData.reduce(function (
                      previousValue,
                      currentValue
                    ) {
                      return (previousValue += parseFloat(
                        currentValue.pendind_qty
                      ));
                    },
                      0);
                    let Commited = pageData.reduce(function (
                      previousValue,
                      currentValue
                    ) {
                      return (previousValue += parseFloat(
                        currentValue.quantity_committed
                      ));
                    },
                      0);
                    let PendingAmount = pageData.reduce(function (
                      previousValue,
                      currentValue
                    ) {
                      return (previousValue += parseFloat(
                        currentValue.net
                      ));
                    },
                      0);
                    return (
                      <>
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={2}>Total Quantity : {numeral(sumQtyPending).format("0,00,0")}
                          </Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <p style={{ textAlign: "right" }} className="totalquantity">
                              {PendingQuantity.toLocaleString("en-US")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <p style={{ textAlign: "right" }} className="totalquantity">
                              {Commited.toLocaleString("en-US")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <p style={{ textAlign: "right" }} className="totalquantity">
                              $ {numeral(PendingAmount).format('0,0.00')}
                            </p>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={2} style={{ paddingTop: "10px", fontWeight: "bolder" }}>Total Amount : ${numeral(sumAmountPending).format("0,0.00")}
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      </>
                    );
                  }}
                />
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ fontSize: "16px", textDecoration: "underline", textDecorationThickness: 2 }}>
                    Pending POD Summary
                  </div>
                  <div style={{ display: "flex", gap: "15px" }}>
                    <CSVLink
                      filename={"booked-summary.csv"}
                      data={pendingPODSummaryExcelData}
                      onClick={() => downloadExcelFileData(pendingPODSummaryList, 'pendingPODSummary')}
                    >
                      <span className="print_icon printing_class">
                        <input
                          style={{ height: "30px" }}
                          type="image"
                          name="ImgExcel"
                          alt="Export to excel"
                          id="ImgExcel"
                          title="Export to excel"
                          src={csv}
                        />
                      </span>
                    </CSVLink>
                    <span className="print_icon printing_class" onClick={() => downloadPDFFileData(pendingPODSummaryList, 'pendingPODSummary')}>
                      <input
                        style={{ height: "30px", cursor: "pointer" }}
                        type="image"
                        name="ImgPdf"
                        alt="Export to PDF"
                        id="ImgPdf"
                        title="Export to PDF"
                        src={pdf}
                      />
                    </span>
                  </div>
                </div>
                <Table
                  ref={tableRef}
                  size="small"
                  bordered={false}
                  type="company"
                  scroll={{ x: 'max-content' }}
                  perPage={5}
                  pagination={{
                    defaultCurrent: 1,
                    defaultPageSize: 5,
                    pageSizeOptions: [5, 20, 50, 100, 200]
                  }}
                  summary={(pageData) => {
                    let sumQty = pageData.reduce(function (
                      previousValue,
                      currentValue
                    ) {
                      return (previousValue += parseFloat(
                        currentValue.quantity
                      ));
                    },
                      0);
                    let Amount = pageData.reduce(function (
                      previousValue,
                      currentValue
                    ) {
                      return (previousValue += parseFloat(
                        Number(currentValue.amount)
                      ));
                    },
                      0);
                    return (
                      <>
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={2}>Total Quantity : {numeral(sumQtyPOD).format("0,00,0")}
                          </Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <p style={{ textAlign: "right" }} className="totalquantity">
                              {sumQty.toLocaleString("en-US")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <p style={{ textAlign: "right" }} className="totalquantity">
                              $ {numeral(Amount).format('0,0.00')}
                            </p>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={2} style={{ paddingTop: "10px", fontWeight: "bolder" }}>Total Amount : ${numeral(sumAmountPOD).format("0,0.00")}
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      </>
                    );
                  }}
                  dataSource={pendingPODSummaryList}
                  columns={columnsPodSummary}
                  loading={pendingPodSummary.loading}
                  paginate
                />
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ fontSize: "16px", textDecoration: "underline", textDecorationThickness: 2 }}>
                    Shipped Summary
                  </div>
                  <div style={{ display: "flex", gap: "15px" }}>
                    <CSVLink
                      filename={"Shipped-Summary.csv"}
                      data={shippedSummaryExcelData}
                      onClick={() => downloadExcelFileData(shippedSummaryList, 'shippedSummary')}
                    >
                      <span className="print_icon printing_class">
                        <input
                          style={{ height: "30px" }}
                          type="image"
                          name="ImgExcel"
                          alt="Export to excel"
                          id="ImgExcel"
                          title="Export to excel"
                          src={csv}
                        />
                      </span>
                    </CSVLink>
                    <span className="print_icon printing_class" onClick={() => downloadPDFFileData(shippedSummaryList, 'shippedSummary')}>
                      <input
                        style={{ height: "30px", cursor: "pointer" }}
                        type="image"
                        name="ImgPdf"
                        alt="Export to PDF"
                        id="ImgPdf"
                        title="Export to PDF"
                        src={pdf}
                      />
                    </span>
                  </div>
                </div>
                <Table
                  ref={tableRef}
                  size="small"
                  bordered={false}
                  type="company"
                  scroll={{ x: 'max-content' }}
                  perPage={5}
                  pagination={{
                    defaultCurrent: 1,
                    defaultPageSize: 5,
                    pageSizeOptions: [5, 20, 50, 100, 200]
                  }}
                  summary={(pageData) => {
                    let sumQty = pageData.reduce(function (
                      previousValue,
                      currentValue
                    ) {
                      return (previousValue += parseFloat(
                        currentValue.quantity
                      ));
                    },
                      0);
                    let Amount = pageData.reduce(function (
                      previousValue,
                      currentValue
                    ) {
                      return (previousValue += parseFloat(
                        Number(currentValue.net)
                      ));
                    },
                      0);
                    return (
                      <>
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={2}>Total Quantity : {numeral(sumQtyShipped).format("0,00,0")}
                          </Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <p style={{ textAlign: "right" }} className="totalquantity">
                              {sumQty.toLocaleString("en-US")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <p style={{ textAlign: "right" }} className="totalquantity">
                              $ {numeral(Amount).format('0,0.00')}
                            </p>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={2} style={{ paddingTop: "10px", fontWeight: "bolder" }}>Total Amount : ${numeral(sumAmountShipped).format("0,0.00")}
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      </>
                    );
                  }}
                  dataSource={shippedSummaryList}
                  columns={columnShippedSummary}
                  loading={getShippedSummaryReducer.loading}
                />
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ fontSize: "16px", textDecoration: "underline", textDecorationThickness: 2 }}>
                    Return Summary
                  </div>
                  <div style={{ display: "flex", gap: "15px" }}>
                    <CSVLink
                      filename={"Return-Summary.csv"}
                      data={returnSummaryExcelData}
                      onClick={() => downloadExcelFileData(returnSummaryList, 'returnSummary')}
                    >
                      <span className="print_icon printing_class">
                        <input
                          style={{ height: "30px" }}
                          type="image"
                          name="ImgExcel"
                          alt="Export to excel"
                          id="ImgExcel"
                          title="Export to excel"
                          src={csv}
                        />
                      </span>
                    </CSVLink>
                    <span className="print_icon printing_class" onClick={() => downloadPDFFileData(returnSummaryList, 'returnSummary')}>
                      <input
                        style={{ height: "30px", cursor: "pointer" }}
                        type="image"
                        name="ImgPdf"
                        alt="Export to PDF"
                        id="ImgPdf"
                        title="Export to PDF"
                        src={pdf}
                      />
                    </span>
                  </div>
                </div>
                <Table
                  size="small"
                  bordered={false}
                  type="company"
                  scroll={{ x: 'max-content' }}
                  perPage={5}
                  pagination={{
                    defaultCurrent: 1,
                    defaultPageSize: 5,
                    pageSizeOptions: [5, 20, 50, 100, 200]
                  }}
                  summary={(pageData) => {
                    let qty = pageData.reduce(function (
                      previousValue,
                      currentValue
                    ) {
                      return (previousValue += parseFloat(
                        currentValue.quantity
                      ));
                    },
                      0);
                    let net = pageData.reduce(function (
                      previousValue,
                      currentValue
                    ) {
                      return (previousValue += parseFloat(
                        currentValue.net === null ? 0 : currentValue.net
                      ));
                    },
                      0);

                    return (
                      <>
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={2}>Total Quantity : {numeral(sumQtyReturn).format("0,00,0")}
                          </Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <p style={{ textAlign: "right" }} className="totalquantity">
                              {qty.toLocaleString("en-US")}
                            </p>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            <p style={{ textAlign: "right" }} className="totalquantity">
                              $ {numeral(net).format('0,0.00')}
                            </p>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                        <Table.Summary.Row>
                          <Table.Summary.Cell colSpan={2} style={{ paddingTop: "10px", fontWeight: "bolder" }}>Total Amount : ${numeral(sumAmountReturn).format("0,0.00")}
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      </>
                    );
                  }
                  }
                  dataSource={returnSummaryList}
                  columns={columnsReturnSummary}
                  loading={getReturnSummaryReducer.loading}
                />
                <div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ fontSize: "16px", textDecoration: "underline", textDecorationThickness: 2 }}>
                      Total Sales by Month
                    </div>
                    <div style={{ display: "flex" }}>
                      <span className="print_icon printing_class" onClick={handleDownload}>
                        <input
                          style={{ height: "30px", cursor: "pointer" }}
                          type="image"
                          name="ImgPdf"
                          alt="Export to PDF"
                          id="ImgPdf"
                          title="Export to PDF"
                          src={pdf}
                        />
                      </span>
                    </div>
                  </div>
                  {sortedEntries.map(([month, data]) => (
                    <div key={month} style={{ marginBottom: "40px" }}>
                      <h4
                        style={{
                          borderBottom: "1px solid black",
                          paddingBottom: "4px",
                          display: "inline-block",
                          fontSize: "16px",
                          marginBottom: "12px",
                        }}
                      >
                        {month.trim()} {/* 👈 Remove trailing spaces from display */}
                      </h4>

                      <div
                        style={{
                          display: "flex",
                          overflowX: "auto",
                          gap: "16px",
                          paddingBottom: "8px",
                        }}
                      >
                        {data?.length > 0 &&
                          data.map((val, i) => (
                            <div
                              key={i}
                              style={{
                                width: "150px",
                                height: "250px",
                                border: "1px solid #ccc",
                                padding: "8px",
                                textAlign: "center",
                                fontSize: "10.5px",
                                fontFamily: "Arial, sans-serif",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                              }}
                            >
                              {/* SKU */}
                              <div
                                className="sku-text"
                              >
                                {val.parent_item_code}
                              </div>

                              {/* Style + Wash */}
                              <div style={{ marginBottom: "4px" }}>
                                <div
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {val.style_name}
                                </div>
                                <div
                                  style={{
                                    color: "#666",
                                    fontSize: "9px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {val.wash_name}
                                </div>
                              </div>

                              {/* Image */}
                              <div
                                style={{
                                  height: "160px",
                                  marginBottom: "6px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  overflow: "hidden",
                                }}
                              >
                                <Image
                                  src={val.image_url}
                                  alt={val.style_name}
                                  width={160}
                                  height={200}
                                  style={{ objectFit: "contain" }}
                                  preview={false}
                                />
                              </div>

                              {/* Quantity */}
                              <div
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "11px",
                                }}
                              >
                                {numeral(val.shipped_qty).format("0")}
                              </div>
                            </div>

                          ))}
                      </div>
                    </div>
                  ))
                  }


                </div>
              </>) : <div
                style={{
                  backgroundColor: "#CCCCCC",
                  borderWidth: "1pt",
                  borderStyle: "Dashed",
                  fontWeight: "bold",
                  height: "25px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
              No record(s)
            </div>
          )
        }
      </div>

    </div>
  )
}

export default CRMReport;